module.exports = __webpack_public_path__ + "static/media/exchange.c301ae6e.svg";